import React from 'react'
import { TextLetterCounter, WrapperLetterCounter } from './styles'
import PropTypes from 'prop-types'
export const LetterCounter = ({ actual, max, style }) => {
  return (
    <WrapperLetterCounter style={style}>
      <TextLetterCounter>{`${actual}/${max}`}</TextLetterCounter>
    </WrapperLetterCounter>
  )
}

LetterCounter.propTypes = {
  actual: PropTypes.number,
  max: PropTypes.number,
  style: PropTypes.object
}
